<template>
	<div class="c-inquiry__body">
				<div class="inquiry-form__title-block">
					<p class="inquiry-form__form-title">{{msg.personal_info}}</p>
					<span class="inquiry-form__required-mark">
						{{msg.required}}
					</span>
				</div>

				<div class="row">
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name+(required_fields.first_name?' *':'')">
						</label>
					</div>
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name+(required_fields.last_name?' *':'')">
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email+(required_fields.email?' *':'')">
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<label class="inquiry-form__label">
							<textarea name="message" rows="8" cols="80" :placeholder="msg.message+(required_fields.message?' *':'')" class="inquiry-form__input-textarea"></textarea>
						</label>
					</div>
				</div>

				<div class="inquiry-form__bottom">
					<div class="inquiry-form__opt">
						<label class="inquiry-form__label">
							<input type="hidden" name="gdpr_accept" value="false" class="inquiry-form__input-check">
							<input type="checkbox" name="gdpr_accept" value="true" class="inquiry-form__input-check">
							<span style="margin-left:5px;" v-html="msg.form_gdpr+(required_fields.gdpr_accept?' *':'')"></span>
						</label>
						<!-- <label class="inquiry-form__label">
							<input type="hidden" name="newsletter_accept" value="false" class="inquiry-form__input-check">
							<input type="checkbox" name="newsletter_accept" value="true" class="inquiry-form__input-check">
							<span style="margin-left:5px;" v-html="msg.form_newsletter+(required_fields.newsletter_accept?' *':'')"></span>
						</label> -->

				</div>

				</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	props: {
		required_fields: Object
	},
	computed: {
		...mapState({
			msg: state => state.msg,
		})
	}
}
</script>

<style>

</style>
